import * as React from 'react'
import { withRouter } from 'react-router'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import HttpActionsService from '../../../Services/HttpActionsService'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import PaymentsStore from '../../../Stores/PaymentsStore'
import {
    PaymentStatus,
    UpdatePaymentStatusRequest
} from '../../../Model/Payment'
import { Button, Modal } from 'react-bootstrap'
const moment = require('moment')

export interface IPaymentCancelProps {
    httpActionsService?: HttpActionsService
    paymentsStore?: PaymentsStore
    localizationStore?: LocalizationStore
    userStore: UserStore
}

@inject('httpActionsService')
@inject('paymentsStore')
@inject('localizationStore')
@inject('userStore')
@observer
export class PaymentCancelView extends React.Component<IPaymentCancelProps> {
    constructor(props: any) {
        super(props)
        this.state = {
            show: false
        }
    }

    showModal() {
        this.setState({ show: true })
    }

    handleClose(e: any, context: PaymentCancelView) {
        context.setState({ show: false })
    }

    render() {
        const { paymentsStore, localizationStore, userStore } = this.props
        let p = paymentsStore!.getItem

        if (!p) {
            return (
                <div>
                    <div className="row">
                        <div className="col-12">
                            {localizationStore!.t('no data')}
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Button
                                onClick={() => { history.push('/payments') }}
                            >
                                {localizationStore!.t!('backToList')}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        let isCancelBtnVisible = false
        try {
            isCancelBtnVisible =
                p.paymentStatus !== PaymentStatus.Canceled &&
                (
                    userStore.checkAdmin ||
                    userStore.checkSuperAdmin ||
                    userStore.checkCashierAdmin ||
                    (
                        userStore.checkCashier &&
                        moment(p.createDate).startOf('day').diff(moment(Date.now()).startOf('day'), 'days') === 0
                    )
                )
        } catch {
            isCancelBtnVisible = false
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12 paymentBtns">

                        <Modal
                            show={this.state['show']}
                            onHide={() => { this.handleClose({}, this) }}
                            animation={false}
                            keyboard={false}
                            backdrop={true}
                        >
                            <div className="formWrapper">
                                <div>
                                    <h4>{localizationStore!.t!('Do you really want to cancel this payment?')}</h4>
                                </div>
                                <Button
                                    className="btn-danger"
                                    hidden={!isCancelBtnVisible}
                                    onClick={
                                        (e) => {
                                            this.props.httpActionsService!
                                                .updatePaymentStatus(new UpdatePaymentStatusRequest(
                                                    p!.id, PaymentStatus.Canceled))
                                            history.push('/payments')
                                            this.setState({ show: false })
                                        }}
                                >
                                    {localizationStore!.t!('CancelPayment')}
                                </Button>
                                <Button
                                    bsStyle="link"
                                    onClick={(e) => { return this.handleClose(e, this) }}
                                >
                                    {localizationStore!.t!('Back')}
                                </Button>
                            </div>
                        </Modal>
                        <Button
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={localizationStore!.t!('CancelPayment')}
                            className="btn-danger btn"
                            hidden={!isCancelBtnVisible}
                            onClick={() => this.showModal()}
                            data-html="true"
                        >
                            {localizationStore!.t!('CancelPayment')}
                        </Button>
                        <a
                            hidden={!p.checkLink}
                            className="btn btn-default"
                            href={p.checkLink}
                        >
                            {localizationStore!.t('DownloadCheck')}
                        </a>
                        <Button
                            className="btn"
                            onClick={() => { history.push('/payments') }}
                        >
                            {localizationStore!.t!('backToList')}
                        </Button>
                    </div>
                </div>

            </div>
        )
    }
}

export default withRouter(PaymentCancelView)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Payment/PaymentCancelView.tsx